'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _license = require('redux/modules/license');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserLicense = function (_React$Component) {
  (0, _inherits3.default)(UserLicense, _React$Component);

  function UserLicense(props) {
    (0, _classCallCheck3.default)(this, UserLicense);
    return (0, _possibleConstructorReturn3.default)(this, (UserLicense.__proto__ || (0, _getPrototypeOf2.default)(UserLicense)).call(this));
  }

  (0, _createClass3.default)(UserLicense, [{
    key: 'onDownloadClick',
    value: function onDownloadClick(e) {
      e.preventDefault();
      this.props.dispatch((0, _license.loadLicenseData)());
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./UserLicense.scss');

      var subscription = this.props.subscription;


      var billing = subscription == undefined ? null : subscription.billing;

      if (billing != 'annual') return null;

      return _react2.default.createElement(
        _components.InfoBox,
        { title: 'Software Licenses', icon: '/icons/license.svg' },
        _react2.default.createElement(
          'div',
          { className: '' + styles.padding16, style: { overflow: 'auto' } },
          _react2.default.createElement(
            'div',
            { className: styles['col-md-12'] },
            _react2.default.createElement(
              'p',
              { className: styles['button-label'] },
              'Quixel Mixer Offline License'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.row },
              _react2.default.createElement(_components.Button, { primary: true, fullWidth: true, label: 'Download', onClick: this.onDownloadClick.bind(this) })
            )
          )
        )
      );
    }
  }]);
  return UserLicense;
}(_react2.default.Component);

var UserLicenseContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user.subscription
  };
}), _dec(_class = function (_React$Component2) {
  (0, _inherits3.default)(UserLicenseContainer, _React$Component2);

  function UserLicenseContainer() {
    (0, _classCallCheck3.default)(this, UserLicenseContainer);
    return (0, _possibleConstructorReturn3.default)(this, (UserLicenseContainer.__proto__ || (0, _getPrototypeOf2.default)(UserLicenseContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserLicenseContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          subscription = _props.subscription,
          dispatch = _props.dispatch;

      return _react2.default.createElement(UserLicense, { subscription: subscription, dispatch: dispatch });
    }
  }]);
  return UserLicenseContainer;
}(_react2.default.Component)) || _class);
exports.default = UserLicenseContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserLicense/UserLicense.jsx
// module id = 2683
// module chunks = 0